/**
 * 全局共享版本号。
 *
 * 规则引擎 / 动作库 / AI Schema 各自独立版本化，用于审计：
 *   - 生成计划时记录所用规则版本（WorkoutPlan.generationRuleVersion）
 *   - 进阶决策记录所用规则版本（ProgressionDecision.ruleVersion）
 *   - AI 估算记录所用 schema 版本（AIEstimate.schemaVersion）
 *
 * 变更规则：任何影响计算/判定结果的改动都必须递增对应版本，否则审计失真。
 */

/** 数据库 / 本地 IndexedDB 结构版本号（用于迁移判断）。阶段 4：v2 新增 syncEntities；阶段 7：v3 新增 progressionDecisions。 */
export const SCHEMA_VERSION = 3;

/** 训练规则引擎版本号（准备度 / 进阶 / 生成 / 力竭 / 体量 / 负荷）。 */
export const RULES_VERSION = "1.0.0";

/** 动作库版本号（种子数据 + 结构化标签）。 */
export const EXERCISE_LIBRARY_VERSION = "1.0.0";

/** 饮食 AI 结构化输出 Schema 版本号。 */
export const NUTRITION_SCHEMA_VERSION = "1.0.0";
